import Reflux from 'reflux';

const ServerAvailabilityActions = Reflux.createActions([
  'reportError',
  'reportSuccess',
]);

export default ServerAvailabilityActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/src/actions/sessions/ServerAvailabilityActions.jsx